module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAABAklEQVQokX3SMS8EURSG4WcnQiMTjUS1SHT67W1UFEIiUbAJGkoa/oFKQqPWsgoJkd3WX1Ai2W4VGoloyK5i5iZjcsfX3fud955zzzm1tDNU0AwOsYRpDPGKW5zjLQTWCuA+zjAqrk9s4waS/HIPF/9AMI42VgI4m2cq6hj3FQ9cIk1wgLGSuYYd3EXACWwmWI6YjTzjbgXcTGTdi6mBK7TwUPLqiazlVZrPS3sq3Q8SvFRA71jEBo5KXi+RDTcGNWX/P4n43VraGU7hWTanoBYmcRqB+pgLm7OO64L5g5EI9J2X/xg2p41VfOTnGNQPEH93FVJsYQF1DNBDVzaarxD4C9tKNqVCfNfDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/remoteControl/img/more.png
// module id = yHF/
// module chunks = 163